var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0a6 6 0 100 12A6 6 0 006 0zm.69 7.993c-.555 0-1.077-.3-1.255-.64 0 0-.299 1.183-.362 1.412-.222.807-.877 1.615-.928 1.682-.035.046-.114.031-.122-.03-.014-.103-.18-1.122.016-1.953l.66-2.8s-.163-.329-.163-.814c0-.762.441-1.33.991-1.33.467 0 .693.35.693.772 0 .47-.3 1.172-.453 1.823-.13.545.273.99.81.99.974 0 1.63-1.25 1.63-2.733 0-1.126-.758-1.97-2.139-1.97-1.558 0-2.53 1.163-2.53 2.462 0 .448.132.764.34 1.008.094.113.107.158.073.287-.025.094-.081.322-.105.412-.034.13-.14.177-.257.129-.718-.293-1.053-1.08-1.053-1.964 0-1.46 1.231-3.21 3.674-3.21 1.962 0 3.253 1.42 3.253 2.944 0 2.017-1.12 3.523-2.773 3.523z",
    fill: "currentColor"
  })));
}

export default SvgPinterest;